<template>
  <b-row>
    <b-col sm="12">
      <b-card header-tag="header" footer-tag="footer">
        <b-row>
          <b-col>
            <h4 id="traffic" class="card-title mb-0">Presupuestos</h4>
            <div class="small text-muted">Administración de todos los presupuestos ingresados al sistema</div>
          </b-col>
        </b-row>
      </b-card>

      <b-row>
        <b-col md="9">
          <b-row>            
            <b-col lg="4">
              <Widget :configWidget="configWidget" reference="indicator_total_amount_budgets_today" :hasAccess="configWidget.elements.indicatorTotalAmountBudgetsToday" />
              <Widget :configWidget="configWidget" reference="indicator_total_budgets_today" :hasAccess="configWidget.elements.indicatorTotalBudgetsToday" />
              <Widget :configWidget="configWidget" reference="list_budgets_close_pending_invoice" :hasAccess="configWidget.elements.listBudgetsClosePendingInvoice" />
            </b-col>
            <b-col lg="8">
              <Widget :configWidget="configWidget" reference="list_next_budgets_expiration" :hasAccess="configWidget.elements.listNextBudgetsExpiration" />              
              <Widget :configWidget="configWidget" reference="bar_budgets_months" :hasAccess="configWidget.elements.barBudgetsMonths" />              
            </b-col>            
          </b-row>
        </b-col>  
        <b-col md="3">

          <b-list-group class="mb-1" v-if="configSubView.elements.budgets">
            <b-list-group-item href="#" class="flex-column align-items-start" @click="openGenerate()">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">Generar</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                Crear y administrar todos los presupuestos emitidos
              </p>
            </b-list-group-item>
          </b-list-group>  

          <hr v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
          <b-list-group class="mt-2" v-if="arr.PHPCustom.length && configSubView.elements.php_custom">
            <b-list-group-item v-for="item in arr.PHPCustom" :key="item.id" href="#" class="flex-column align-items-start" @click="openPHPCustom(item)">
              <div class="d-flex w-100 justify-content-between">
                <h5 class="mb-1">{{item.name}}</h5>
                <small>
                  <b-icon icon="chevron-double-right" class="h5"></b-icon>
                </small>
              </div>

              <p class="mb-1">
                {{item.observations}}
              </p>
            </b-list-group-item>
          </b-list-group>
        </b-col>        
      </b-row>

    </b-col>
  </b-row>
</template>
<script>
  //import serviceAPI from './services'
  import Error from '@/handler/error'
  import Session from '@/handler/session'
  import Profiles from '@/config/profiles'
  import Modules from '@/config/modules'
  import Helper from '@/handler/helper'
  import Widget from '@/components/inc/widget/widget'
  import ServicesPHP from '@/components/modules/users/php/staff/services'

  export default {
    components: {
      Widget
    },
    data: () => {
      return {
        access: {
          module_id: Modules.PRESUPUESTOS,
          profile_id: Profiles.PERSONAL,
          view_reference: 'dashboard',
          elements: {}
        },
        configWidget: {
          module_id: Modules.PRESUPUESTOS,
          profile_id: Profiles.PERSONAL,
          elements: {             
            indicatorTotalAmountBudgetsToday: true,
            indicatorTotalBudgetsToday: true,
            barBudgetsMonths: true,
            listNextBudgetsExpiration: true,
            listBudgetsClosePendingInvoice: true,
          }
        },
        configSubView: {
          module_id: Modules.PRESUPUESTOS,
          profile_id: Profiles.PERSONAL,
          elements: {
            budgets: true,
            php_custom: true,
          }
        },         
        primaryColor: '',
        arr: {
          PHPCustom: []
        }        
      }
    },
    created () {
      /* Configurar permisos de vistas y elementos */
      Helper.hasAccessView(this.access)
      /* Fin configuracion */

      /* Configurar permisos de los widgets */      
      this.configWidget.elements.indicatorTotalAmountBudgetsToday = Helper.hasAccessWidget(this.configWidget, 'indicator_total_amount_budgets_today')
      this.configWidget.elements.indicatorTotalBudgetsToday = Helper.hasAccessWidget(this.configWidget, 'indicator_total_budgets_today')
      this.configWidget.elements.barBudgetsMonths = Helper.hasAccessWidget(this.configWidget, 'bar_budgets_months')
      this.configWidget.elements.listNextBudgetsExpiration = Helper.hasAccessWidget(this.configWidget, 'list_next_budgets_expiration')      
      this.configWidget.elements.listBudgetsClosePendingInvoice = Helper.hasAccessWidget(this.configWidget, 'list_budgets_close_pending_invoice')      
      /* Fin configuracion */

      /* Configurar permisos de las sub vistas */
      this.configSubView.elements.budgets = Helper.showAccessView(this.configSubView, 'budgets')
      this.configSubView.elements.php_custom = Helper.showAccessPHPCustom()
      /* Fin configuracion */            
    },
    mounted() {
      this.setup()
      this.getPHPCustom()
    },
    methods: {
      setup () {        
        if(Session.getSession().settings) {    
          this.primaryColor = Session.getSession().settings.color_primary
                    
          this.createCSS()
        }
      },
      createCSS() {
        var hoja = document.createElement('style')
        hoja.innerHTML = ""      
        hoja.innerHTML = hoja.innerHTML  + ".list-group-item-action:hover, .list-group-item-action:focus { background-color: " + this.primaryColor + "; }"

        document.body.appendChild(hoja);
      },
      openGenerate() {
        this.$router.push({ name: 'BudgetsStaffCrudBudget' })
      },

      getPHPCustom() {
        ServicesPHP.obtenerPHPByModule(Modules.PRESUPUESTOS)
        .then((response) => {
          this.arr.PHPCustom = response.data       
        })
      },
      openPHPCustom(item) {
        this.$router.push({ name: 'ViewStaffViewPHPCustom', params: {id: item.id} })
      }      
    }    
   
  }
</script>

<style>

</style>
